import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaLinkedin, FaGithub, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import './Contact.css';

const contactInfo = [
  { icon: <FaEnvelope />, label: 'Email', value: 'sudipmazkoti@gmail.com', href: 'mailto:sudipmazkoti@gmail.com' },
  { icon: <FaPhone />, label: 'Phone', value: '+977 9813663763', href: 'tel:+9779813663763' },
  { icon: <FaLinkedin />, label: 'LinkedIn', value: 'sudipmajkoti', href: 'https://linkedin.com/in/sudipmajkoti' },
  { icon: <FaGithub />, label: 'GitHub', value: 'sudipmajkoti07', href: 'https://github.com/sudipmajkoti07' },
  { icon: <FaMapMarkerAlt />, label: 'Location', value: 'Bhaktapur, Nepal', href: null },
];

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Get In Touch'}</span>
          <h2 className="section-title">Contact Me</h2>
          <p className="section-subtitle">
            Feel free to reach out for collaborations, projects, or just to say hello!
          </p>
        </div>

        <motion.div
          className="contact__content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="contact__info">
            <h3 className="contact__info-title">Let's Connect</h3>
            <p className="contact__info-desc">
              I'm always open to discussing AI projects, innovative ideas, or potential
              collaborations. Don't hesitate to reach out!
            </p>

            <div className="contact__items">
              {contactInfo.map((item, idx) => (
                <motion.div
                  className="contact__item"
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1, duration: 0.4 }}
                >
                  <div className="contact__item-icon">{item.icon}</div>
                  <div>
                    <span className="contact__item-label">{item.label}</span>
                    {item.href ? (
                      <a href={item.href} target="_blank" rel="noreferrer" className="contact__item-value">
                        {item.value}
                      </a>
                    ) : (
                      <span className="contact__item-value">{item.value}</span>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <div className="contact__form-wrap">
            <form className="contact__form" action={`mailto:sudipmazkoti@gmail.com`} method="post" encType="text/plain">
              <div className="contact__form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" placeholder="Your name" required />
              </div>
              <div className="contact__form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" placeholder="your@email.com" required />
              </div>
              <div className="contact__form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" name="subject" placeholder="How can I help?" />
              </div>
              <div className="contact__form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows="5" placeholder="Your message..." required />
              </div>
              <button type="submit" className="btn btn-primary contact__submit">
                <FaPaperPlane /> Send Message
              </button>
            </form>
          </div>
        </motion.div>

        {/* References */}
        <motion.div
          className="contact__references"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3 className="contact__ref-title">References</h3>
          <div className="contact__ref-grid">
            <div className="contact__ref-card">
              <h4>Rajan Adhikari</h4>
              <span className="contact__ref-role">Solution Architect</span>
              <p><FaPhone /> +977 9851245288</p>
              <p><FaEnvelope /> rajanadhikari@gmail.com</p>
            </div>
            <div className="contact__ref-card">
              <h4>Sadikshya Ghimire</h4>
              <span className="contact__ref-role">AI Research Associate — Palm Mind Technology</span>
              <p><FaEnvelope /> sadikshyaghimire107@gmail.com</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
